var map = {
	"./IPS1.gif": 3417,
	"./IPS2.png": 7105,
	"./IPS3.png": 9240,
	"./IPS4.png": 4407,
	"./IPS5.png": 6094,
	"./IPS6.png": 3445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5899;